// extracted by mini-css-extract-plugin
export var info = "info-module--info--c0b7d";
export var info__item = "info-module--info__item--f60db";
export var info__link = "info-module--info__link--77dfb";
export var info__list = "info-module--info__list--15134";
export var info__txt = "info-module--info__txt--1f504";
export var info__txtSeparate = "info-module--info__txt-separate--1c104";